/* eslint-disable no-console */

function shouldDeleteCache (cacheName) {
  return cacheName.indexOf('qrapph5') === 0 || cacheName.indexOf('workbox') === 0
}

async function cleanupServiceWorkers () {
  if (!('serviceWorker' in navigator)) return

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map(registration => registration.unregister()))

    if ('caches' in window) {
      const cacheNames = await window.caches.keys()
      await Promise.all(
        cacheNames
          .filter(shouldDeleteCache)
          .map(cacheName => window.caches.delete(cacheName))
      )
    }
  } catch (error) {
    console.error('Error during service worker cleanup:', error)
  }
}

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('load', cleanupServiceWorkers)
}
